export function getAll() {
  return [
    {
      value: 0,
      name: "TimeRange",
      text: "指定日期",
    },
    {
      value: 1,
      name: "ValidPeriod",
      text: "有效期限",
    },
    {
      value: 2,
      name: "Unlimited",
      text: "無使用期限",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
